// extracted by mini-css-extract-plugin
module.exports = {"select-input":"select-input__2LNiQ","s":"s__3wlPY","card":"card__3HbxQ","m":"m__2lFno"};